Hop.defineModule('password-constraint-checker', (root) => {
    const SPECIAL_CHARS_REGEX = /[!@#£$%^&`~*()_+\-=[\]{};':"\\|,.<>/?]+/;
    const UPPERCASE_REGEX = /[A-Z\u00C0-\u00DC]+/;

    const $root = $(root);
    const $form = $root.closest('form');
    const $passwordInput = $($root.data('target'));

    const constraints = [
        {check: (s) => s.length >= 8, target: $root.find('[data-constraint="lengthConstraint"]')},
        {check: (s) => s.search(UPPERCASE_REGEX) >= 0, target: $root.find('[data-constraint="uppercaseConstraint"]')},
        {check: (s) => s.search(SPECIAL_CHARS_REGEX) >= 0, target: $root.find('[data-constraint="specialConstraint"]')},
    ];

    function checkIfAllContraintsAreValid(elem) {
        const listElemToCheck = elem.target[0];
        return listElemToCheck.classList[0] === 'constraint-valid';
    }

    function sendGtmEvent() {
        if (constraints.every(checkIfAllContraintsAreValid) && !$passwordInput[0].hasAttribute('data-gtm-sent-event')) {
            Hop.gtm.push(JSON.parse($passwordInput[0].getAttribute('data-gtm')));
        }

        if (constraints.every(checkIfAllContraintsAreValid)) {
            $passwordInput[0].setAttribute('data-gtm-sent-event', '');
        }
    }

    function checkConstraints() {
        const password = $passwordInput.val();

        if (password) {
            for (let i = 0; i < constraints.length; ++i) {
                const constraint = constraints[i];

                if (constraint.check(password)) {
                    constraint.target.addClass('constraint-valid').removeClass('constraint-invalid');
                } else {
                    constraint.target.addClass('constraint-invalid').removeClass('constraint-valid');
                }
            }

            if ($passwordInput[0].hasAttribute('data-gtm')) {
                sendGtmEvent();
            }
        } else {
            // if we empty the field, we need to reset it
            resetConstraints();
        }
    }

    function resetConstraints() {
        for (let i = 0; i < constraints.length; ++i) {
            const constraint = constraints[i];
            constraint.target.addClass('constraint-invalid').removeClass('constraint-valid');
        }
    }

    function validateField(e) {
        const password = $passwordInput.val();

        for (let i = 0; i < constraints.length; ++i) {
            const constraint = constraints[i];

            if (!constraint.check(password)) {
                e.preventDefault();
                $passwordInput[0].setCustomValidity(Hop.message('password.constraints.not.respected.error'));
                Hop.formFn.addMessage($form);
                return;
            }
        }
    }

    $passwordInput.on('input change keyup onpropertychange', checkConstraints);
    $form.submit(validateField);

    checkConstraints();

    return function destroy() {
        $passwordInput.off('input change keyup onpropertychange', checkConstraints);
    };
});
